interface SearchURLObj {
  name: string;
  slug: string;
  lang: string;
  genericSlug: string;
}

interface SearchQueryObj {
  name?: string;
  slug?: string;
}

export const decodeSearchQuery = (query: string): SearchQueryObj => {
  try {
    let json;

    if (typeof atob !== 'undefined') {
      json = JSON.parse(atob(decodeURIComponent(query)));
    } else {
      json = JSON.parse(Buffer.from(decodeURIComponent(query || ''), 'base64').toString('ascii'));
    }

    const ret: SearchQueryObj = {
      name: json.n,
    };

    return ret;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return {};
  }
};

export const encodeSearchQuery = (name: string): string | null => {
  const queryStr = JSON.stringify({
    n: name,
  });

  if (typeof btoa !== 'undefined') {
    return btoa(queryStr);
  }

  return encodeURIComponent(Buffer.from(queryStr).toString('base64'));
};

export const getSearchURL = ({ lang, name, slug, genericSlug }: SearchURLObj): string => {
  let url = `${lang.includes('es') ? '/es' : ''}/drugs/${genericSlug || slug}`;
  const query = [];

  if (genericSlug && genericSlug !== slug) {
    query.push(`d=${encodeSearchQuery(name)}`);
  }

  if (query.length) {
    url = `${url}?${query.join('&')}`;
  }

  return url;
};
